import { render, staticRenderFns } from "./Transaksi.vue?vue&type=template&id=abb5dfb2"
import script from "./Transaksi.vue?vue&type=script&lang=js"
export * from "./Transaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports